import React from 'react'
import ReactModal from 'react-modal'
import styled from 'styled-components'
import { useWindowSize } from 'react-use'
import ErrorBoundary from 'components/errorBoundary'
import MediaPlayer from './MediaPlayer'
import closeIcon from 'images/icons/close_with_bg.svg'

const Container = styled.div`
  width: 100%;
  position: relative;
`
const CloseIcon = styled.img`
  position: absolute;
  top: 12px;
  right: 12px;
  width: 38px;
  height: 38px;
  cursor: pointer;
`

const VideoModal = ({ isOpen, setOpenModal, videoUrl = '' }) => {
  const { width } = useWindowSize()
  const modalStyle = {
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.4)',
    },
    content: {
      top: '0',
      left: '0',
      right: '0',
      bottom: '0',
      margin: 'auto',
      border: 'none',
      background: '#000000',
      width: width < 1000 ? '100%' : 1000,
      height: 'fit-content',
      padding: 0,
    },
  }

  const onClose = () => {
    setOpenModal(false)
  }

  return (
    <ErrorBoundary>
      <ReactModal isOpen={isOpen} style={modalStyle} onRequestClose={onClose}>
        <Container>
          <MediaPlayer url={videoUrl} isShowVideoWidth={false} />
          <CloseIcon src={closeIcon} onClick={onClose} />
        </Container>
      </ReactModal>
    </ErrorBoundary>
  )
}

export default VideoModal
